{
  "data_records_grid": {
    "columns": "Columns"
  },
  "custom_objects": {
    "import_error": "Import Error",
    "export_all": "Export All"
  }
}
